import React from "react";

const Reviews = () => {
  return (
    <div className="h-full dark:bg-[#292930] pb-20 pt-36">
      <img
        className="absolute left-0 -mt-10 -scale-x-100 z-[-10]"
        src="https://new.axilthemes.com/demo/react/abstrak/images/others/line-6.png"
        alt=""
      />
      <h1 className="text-5xl dark:text-[#d3d3d4] text-center font-bold font-dmsans">
        Our Reviews
      </h1>
      <div className="mt-16 z-1 flex justify-center gap-8">
        <div className="bg-white flex flex-col dark:bg-[#212121] items-center justify-center h-64 rounded-xl w-400">
          <div className="flex flex-col items-center">
            <div className="rounded-full h-14 flex items-center justify-center w-14 mt-2 bg-[#FFDC60] ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-22.png"
                className=""
                alt=""
              />
            </div>
            <div className="mt-1 mx-2 dark:text-[#d3d3d4]  ">
              <p className="text-center ">
                My experience with Chabbhikar was phenomenal and so satisfying.
                The quality of services they provide to their customers is very
                good. Easy to communicate and get quick response from the team.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white flex dark:bg-[#212121] flex-col items-center justify-center h-64 rounded-xl w-400">
          <div className="flex flex-col items-center">
            <div className="rounded-full h-14 flex items-center justify-center w-14 mt-2 bg-[#FFDC60] ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-22.png"
                className=""
                alt=""
              />
            </div>
            <div className="mt-1 ml-3 mr-3 dark:text-[#d3d3d4]">
              <p className="text-center">
                I really liked the artwork they have delivered me for my wall
                along with the customization options. I had queries and specific
                requests for which I reached out over their site. They were
                prompt to respond and catered to my additional request.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white flex dark:bg-[#212121] flex-col items-center justify-center h-64 rounded-xl w-400">
          <div className="flex flex-col items-center">
            <div className="rounded-full h-14 flex items-center justify-center w-14 mt-2 bg-[#FFDC60] ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-22.png"
                className=""
                alt=""
              />
            </div>
            <div className="mt-1 ml-3 mr-3 dark:text-[#d3d3d4]">
              <p className="text-center">
                It was an amazing experience with the team. I just love the work
                they do on my bedroom/any wall. Amazing experience with them.
                They don't take a lot of time to do this fantastic work.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
